import React, { useState } from 'react'
import moment from 'moment'
import {
  Modal,
  Form,
  Input,
  DatePicker,
  Radio,
  TimePicker,
  Avatar,
  Card,
  Row,
  Col,
  Button,
  Spin
} from 'antd'
import { disabledBeforeCurrentDate } from '../../../../utils/dateTime'
import { ButtonEx } from '../../../../styles/button.style'

const NotiCenterModal = ({
  visibleNotiCenter,
  onOkNotiCenter,
  onCloseNotiCenter,
  selectedRowKeys,
  onChangeRadio,
  value,
  form,
  isLoadingNoti
}) => {
  const { getFieldDecorator, validateFields } = form
  const [characterTitleCount, setcharacterTitleCount] = useState(0)
  const [characterMessageCount, setcharacterMessageCount] = useState(0)
  const [heroIds, setHeroIds] = useState([])

  const clearHeroIds = () => {
    setHeroIds([])
  }

  function onSubmit(e) {
    e.preventDefault()

    validateFields(async (err, values) => {
      if (!err) {
        const schedulingDateTime = values.schedulingDate
        const time = values.schedulingTime

        if (values.isNow === 0) {
          schedulingDateTime.set({
            hour: time.get('hour'),
            minute: time.get('minute'),
            second: '00',
            millisecond: '000'
          })
        }

        selectedRowKeys.map((row) => {
          heroIds.push(row.id)
          return heroIds
        })

        const data = {
          userReceiverTypeId: 3,
          title: values.title,
          message: values.message,
          schedulingDate: moment(schedulingDateTime),
          notificationActionId: values.userReceiverTypeId === 2 ? 2 : 1,
          userReceiverIds: heroIds,
          isNow: values.isNow
        }
        if (values.url) {
          data.url = values.url
        } else {
          data.url = ''
        }
        await onOkNotiCenter(data)
        await form.resetFields()
        clearHeroIds()
      }
    })
  }

  return (
    <Modal
      title="ส่งการเตือนไปยังผู้ใช้"
      visible={visibleNotiCenter}
      onOk={onSubmit}
      onCancel={onCloseNotiCenter}
      footer={null}
      width={1200}>
      <Spin spinning={isLoadingNoti}>
        <Form onSubmit={onSubmit} layout="vertical">
          <Form.Item label="หัวเรื่อง">
            {getFieldDecorator(`title`, {
              rules: [
                {
                  required: true,
                  message: 'กรุณากรอก'
                }
              ]
            })(
              <Input
                onChange={(e) => setcharacterTitleCount(e.target.value.length)}
              />
            )}
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-end',
                flexDirection: 'column'
              }}>
              {characterTitleCount}
            </div>
          </Form.Item>
          <Form.Item label="เนื้อหา">
            {getFieldDecorator(`message`, {
              rules: [
                {
                  required: true,
                  message: 'กรุณากรอก'
                }
              ]
            })(
              <Input
                onChange={(e) =>
                  setcharacterMessageCount(e.target.value.length)
                }
              />
            )}
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-end',
                flexDirection: 'column'
              }}>
              {characterMessageCount}
            </div>
          </Form.Item>
          <Form.Item label="Notification URL">
            <Input />
          </Form.Item>
          <Form.Item label="เป้าหมายการส่ง">
            <Card>
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {selectedRowKeys.map((row) => {
                  return (
                    <Card
                      style={{
                        width: 'auto',
                        height: 'auto',
                        marginTop: 16
                      }}>
                      <Avatar src={row.imageUrl} />
                      {row.name}
                    </Card>
                  )
                })}
              </div>
            </Card>
          </Form.Item>
          <Form.Item label="ส่งเวลา">
            <Card>
              {getFieldDecorator(`isNow`, {
                initialValue: true,
                rules: [
                  {
                    required: true,
                    message: 'กรุณากรอก'
                  }
                ]
              })(
                <Radio.Group onChange={onChangeRadio} value={value}>
                  <Radio value={1}>ทันที</Radio>
                  <Radio value={0}>กำหนดเวลา</Radio>
                </Radio.Group>
              )}

              {value === 0 && (
                <div>
                  {getFieldDecorator(`schedulingDate`, {
                    rules: [
                      {
                        required: true,
                        message: 'กรุณากรอก'
                      }
                    ]
                  })(<DatePicker disabledDate={disabledBeforeCurrentDate} />)}
                  {getFieldDecorator(`schedulingTime`, {
                    rules: [
                      {
                        required: true,
                        message: 'กรุณากรอก'
                      }
                    ]
                  })(
                    <TimePicker
                      format={'HH:mm'}
                      minuteStep={10}
                      style={{ marginTop: 29 }}
                    />
                  )}
                </div>
              )}
            </Card>
          </Form.Item>
          <Row type="flex" gutter={8} justify="end">
            <Col>
              <Button onClick={() => onCloseNotiCenter()}>ยกเลิก</Button>
            </Col>
            <Col>
              <ButtonEx color="#6ebf4b" type="primary" htmlType="submit" load>
                บันทึก
              </ButtonEx>
            </Col>
          </Row>
        </Form>
      </Spin>
    </Modal>
  )
}

const WrappedNotiCenterModal = Form.create({ name: 'NotiCenterModal' })(
  NotiCenterModal
)

export default WrappedNotiCenterModal
